import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { notifyError } from "../../utils/notifications";
import { WkoLoadingSpinner } from "../WkoLoadingSpinner";
export const TopNcLocations = ({ options, selectedLocationId, title = "Locations with most NCs (your fleet)", }) => {
    const [loading, setLoading] = useState(false);
    const [locations, setLocations] = useState([]);
    useEffect(() => {
        if (!options.isReady)
            return;
        setLocations([]);
        setLoading(true);
        const query = new URLSearchParams({
            fromMonth: options.startDate.substring(0, 7),
            toMonth: options.endDate.substring(0, 7),
            fleets: options.fleet.map((f) => f.ID).join(","),
            regionId: options.region === undefined || options.region === "*" ? "" : options.region,
        });
        fetch(`/api/benchmark/topnclocations?${query}`)
            .then((res) => {
            if (res.ok)
                return res.json();
            throw new Error(res.statusText);
        })
            .then((data) => {
            setLocations(data);
        })
            .catch(() => {
            notifyError("An error has occurred when loading top NC locations. Please try again.");
        })
            .finally(() => setLoading(false));
    }, [options.isReady, options.startDate, options.endDate, options.fleet.map((f) => f.ID).join(","), options.region]);
    return (_jsxs(_Fragment, { children: [_jsx("h2", { children: "Locations with most NCs (your fleet)" }), _jsx("div", { className: "card shadow", children: loading ? (_jsx(WkoLoadingSpinner, {})) : locations.length > 0 ? (_jsx("div", { className: "list-group", children: locations.map((location) => (_jsxs("a", { href: "#", className: `list-group-item list-group-item-action justify-content-between d-flex py-2${options.locationId === location.LocationId ? " active" : ""}`, onClick: (e) => {
                            e.preventDefault();
                            selectedLocationId?.(location.LocationId);
                        }, children: [_jsx("span", { children: location.LocationName }), _jsxs("span", { children: [location.NcDays, " nc days"] })] }, location.LocationId))) })) : (_jsx("div", { className: "p-2", style: { height: "11.371rem" }, children: _jsx("p", { className: "text-secondary text-center mb-0", children: "No data for this selection." }) })) })] }));
};
